import { render, staticRenderFns } from "./serviceAttachment.vue?vue&type=template&id=e71b2d04&scoped=true&"
import script from "./serviceAttachment.vue?vue&type=script&lang=js&"
export * from "./serviceAttachment.vue?vue&type=script&lang=js&"
import style0 from "./serviceAttachment.vue?vue&type=style&index=0&id=e71b2d04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71b2d04",
  null
  
)

export default component.exports